
import XcoinsMoreProducts from "@/components/xcoins/MoreProducts.vue";
import { formatPoints, isPointsApiSuccess } from "@/utils/mallGoods";
import { getOrderDeliveryNote, getOrderDetailName, getSoftwareCode } from "@/utils/mallExchange";
import { ensureMallSite, openMallCouponSite, resolveSelectedMallSiteDomain } from "@/utils/mallSite";

export default {
  name: "XcoinsRedeemResult",
  components: { XcoinsMoreProducts },
  layout: "DefaultLayout",
  head() {
    return { title: this.$t("xcoins.REDEMPTION_SUCCESSFUL") };
  },
  data() {
    return {
      result: null,
      pageLoading: true,
      copying: false,
      openingCoupon: false,
      couponSiteUrl: "", // 当前选中国家的站点域名，缺失则隐藏按钮
    };
  },
  computed: {
    orderId() {
      return this.$route.params.id;
    },
    goodsId() {
      return this.$route.query.goodsId || "";
    },
    productName() {
      return (this.result && this.result.goodsName) || this.$t("xcoins.XCOINS_SHOP");
    },
    goodsType() {
      return this.result ? Number(this.result.goodsType) : 0;
    },
    isSoftware() {
      return this.goodsType === 1;
    },
    isPhysical() {
      return this.goodsType === 2;
    },
    isCoupon() {
      return this.goodsType === 3;
    },
    softwareCode() {
      return getSoftwareCode(this.result);
    },
    specText() {
      return getOrderDetailName(this.result);
    },
    deliveryNote() {
      return getOrderDeliveryNote(this.result);
    },
    myRedeemPath() {
      return { path: "/user/xcoins", query: { tab: "exchange" } };
    },
    resultTitle() {
      if (this.isSoftware) {
        return this.$t("xcoins.SOFTWARE_REDEEM_SUCCESS");
      }
      if (this.isPhysical) {
        return this.$t("xcoins.PHYSICAL_REDEEM_SUCCESS");
      }
      if (this.isCoupon) {
        return this.$t("xcoins.COUPON_REDEEM_SUCCESS");
      }
      return this.$t("xcoins.REDEMPTION_SUCCESSFUL");
    },
    resultDesc() {
      if (this.isSoftware) {
        return this.$t("xcoins.SOFTWARE_REDEEM_TIP");
      }
      if (this.isPhysical) {
        return this.$t("xcoins.PHYSICAL_REDEEM_TIP");
      }
      if (this.isCoupon) {
        return this.$t("xcoins.COUPON_REDEEM_TIP");
      }
      return "";
    },
  },
  mounted() {
    this.bootstrap();
  },
  methods: {
    formatPoints,
    /** 按订单 ID 拉取兑换快照，刷新页面不重复扣积分 */
    async bootstrap() {
      this.pageLoading = true;
      try {
        await ensureMallSite(this.$cookies);
        if (!this.orderId) {
          this.result = null;
          return;
        }
        const res = await this.$pointsCache.requestWithPointToken((token) => {
          return this.$global.pointsMallOrderDetail(this.orderId, token);
        }).catch(() => null);
        this.result = isPointsApiSuccess(res) && res.data ? res.data : null;
        this.couponSiteUrl = this.isCoupon
          ? await resolveSelectedMallSiteDomain(this.$global, this.$cookies)
          : "";
      } finally {
        this.pageLoading = false;
      }
    },
    /** 打开当前选中国家对应的商城站点 */
    async openCouponSite() {
      if (this.openingCoupon) {
        return;
      }
      this.openingCoupon = true;
      try {
        const url = this.couponSiteUrl || await resolveSelectedMallSiteDomain(this.$global, this.$cookies);
        this.couponSiteUrl = url;
        if (!url) {
          return;
        }
        openMallCouponSite(url);
      } finally {
        this.openingCoupon = false;
      }
    },
    async copySoftwareCode() {
      if (!this.softwareCode || this.copying) {
        return;
      }
      this.copying = true;
      try {
        await this.$copyText(this.softwareCode);
        this.$message.success(this.$t("page.COPY_SUCCESS"));
      } catch (e) {
        this.$message.error(this.$t("xcoins.COPY_MANUAL"));
      } finally {
        this.copying = false;
      }
    },
  },
};
